import React, { useContext, useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import GlobalContext from "contexts/GlobalContext";
import Page from "pages/Page";
import { ValueAppWidget, usePathFactory, useTranslator } from "@sia/style-guide";
import pgAdapter from "common/Adapters/PGAdapter/PGAdapter";
import { AppBack } from "@sia/style-guide";
import "./../ValueApp.scss";

const ValueAppWidgetPage = () => {
  const { id } = useParams();
  const [entry, setEntry] = useState(null);
  const { language } = useContext(GlobalContext);
  const translate = useTranslator();
  const history = useHistory();
  const pathFactory = usePathFactory();
  const apiKey = process.env.REACT_APP_VALUE_APP_KEY;
  const [meta, setMeta] = useState(null);
  const [isProjectLoaded, setIsProjectLoaded] = useState(false);

  const fetchProjectData = () => {
    if (!id) return;
    pgAdapter.getValueAppProjectList(
      (response) => {
        const { data } = response;
        const project = data.find((p) => p.project_id === id);
        if (!project) {
          console.warn("No project found for ID:", id);
          setIsProjectLoaded(true);
          return;
        }
        setEntry(project.data);
        setMeta({
          canEdit: true,
          canView: true,
          roles: ["ARCHITECT"],
          isGp: false,
          parts: ["ARCHITECT"],
          title: project.title,
          userId: "de000000-0000-0000-0000-000000000000",
        });
        setIsProjectLoaded(true);
      },
      (error) => {
        console.error("Error retrieving project:", error);
        setIsProjectLoaded(true);
      }
    );
  };

  useEffect(() => {
    setEntry(null);
    setMeta(null);
    setIsProjectLoaded(false);
    fetchProjectData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleSaveProject = (data) => {
    pgAdapter.updateValueAppProject(
      {
        data: data,
        project_id: id,
      },
      (response) => {
        console.log("Project updated successfully.");
      },
      (error) => {
        console.error("Error updating project:", error);
      }
    );
  };

  const getLocale = (shortLocale) => {
    const locales = {
      de: "de-CH",
      en: "en",
      fr: "fr",
      it: "it",
    };
    return locales[shortLocale];
  };
  const onClickBack = () => {
    history.push(pathFactory.create("value-app/manage"));
  };

  return (
    language && (
      <Page title={translate("header.app-switcher.value-app.name")} className="ValueApp-Widget-Page">
        <AppBack onClick={onClickBack} />
        <div className="ValueApp-Widget">
          {isProjectLoaded && meta && (
            <ValueAppWidget apiKey={apiKey} meta={meta} entry={entry || ""} lang={getLocale(language)} onSaveCallback={handleSaveProject} />
          )}
        </div>
      </Page>
    )
  );
};

export default ValueAppWidgetPage;
